// Public VAPID key (safe to ship to browsers). The matching PRIVATE key is the secret VAPID_PRIVATE_KEY on the server.
export const VAPID_PUBLIC_KEY = 'BGDhF1iqTMhi7tpmSvOpEgeaaSPtELmELD0tGU5WSwCPuLiJW27ebFTIEHUuoud_12ot2s5qX8dsRgpn5ufAmjc'
